import { useEffect } from 'react';

window.GTM_ID = import.meta.env.VITE_GTM_ID as string;

const GoogleTagManager = () => {
  useEffect(() => {
    if (window.GTM_ID && !document.getElementById('googleTagManager')) {
      const script = document.createElement('script');

      script.type = 'text/javascript';
      script.src = '/assets/gtm.js';
      script.defer = true;
      script.id = 'googleTagManager';

      document.body.appendChild(script);
    }
  }, []);

  return null;
};

export default GoogleTagManager;
